import { render, staticRenderFns } from "./menuItem.vue?vue&type=template&id=47b87eb5&scoped=true&functional=true&"
import script from "./menuItem.vue?vue&type=script&lang=js&"
export * from "./menuItem.vue?vue&type=script&lang=js&"
import style0 from "./menuItem.vue?vue&type=style&index=0&id=47b87eb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "47b87eb5",
  null
  
)

export default component.exports